'use strict';

import React from 'react';

import FormCheckbox from "./FormCheckbox/FormCheckbox";
import FormDropdown from "./FormDropdown/FormDropdown";


const FormElement = ({ form, onschedState, formInputKey, onChange, onBlur }) => {
  const [children, setChildren] = React.useState(null);
  const [display, setDisplay] = React.useState("true");
  const [dynamicTrigger, setDynamicTrigger] = React.useState(!display);
  // let children = null;

  const formatSelectOptions = (inputOptions) => inputOptions.map(
    (c, i) => c.type === 'optgroup'
      ? <optgroup key={i} value={c.value} label={c.name}></optgroup>
      : <option key={i} value={c.value}>{c.name}</option>
      // : <option key={i} value={c.value} selected={i === 0 ? true : false}>{c.name}</option>
  )
  
  let input = form[formInputKey];
  let component = input.component;

  if (input.display === "false") {
    return null;
  }

  React.useEffect(() => {
    if (input.children) {
      // Use the form default to create the inputs
      setChildren(formatSelectOptions(input.children));
    }
    if (input.type === 'checkbox') {
      setChildren(<FormCheckbox input={input} defaultChecked={false} />)
    }
  }, []);
  
  React.useEffect(() => {
    // This updates when any API onschedState from the parent is updated
    // All onschedState objects must use keys that tell the component where 
      // to update the value (i.e. value, children, placeholder, etc)
    if (onschedState?.state) {
      if (formInputKey === 'timezoneName' && onschedState.state.timezones) {
        let newChildren = [];
  
        onschedState.state.timezones.regions.forEach(region => {
          const regionTimezones = onschedState.state.timezones.timezones.filter(t => t.region === region)
                                                                        .map(t => ({type: 'option', name: t.name, value: t.timezoneIanna}));
          const regionOptgroup = [{
            name: region,
            value: region,
            type: 'optgroup'
          }];
          
          const regionArr = regionOptgroup.concat(regionTimezones);
          newChildren.push(regionArr);
        })

        setChildren(formatSelectOptions(newChildren.flat()));
      }
      if (onschedState.state[formInputKey]) {
        Object.keys(onschedState.state[formInputKey]).forEach(dataType => {
          if (dataType === 'value') {
            // Updating the value of a text input
            input.value = onschedState.state[dataType];
          }
          else if (dataType === 'children') {
            // Updating dropdown results
            switch (onschedState.state[formInputKey][dataType].object) {
              // // Updating timezone dropdown
              // case 'timezone':
              //   let newChildren = [];
  
              //   onschedState.state[formInputKey][dataType].regions.forEach(region => {
              //     const regionTimezones = onschedState.state[formInputKey][dataType].timezones.filter(t => t.region === region)
              //                                                                   .map(t => ({type: 'option', name: t.name, value: t.timezoneIanna}));
              //     const regionOptgroup = [{
              //       name: region,
              //       value: region,
              //       type: 'optgroup'
              //     }];
                  
              //     const regionArr = regionOptgroup.concat(regionTimezones);
              //     newChildren.push(regionArr);
              //   })

              //   setChildren(formatSelectOptions(newChildren.flat()));
              //   break;
            
              // default:
              //   break;
            }
          }
        })
      }
    }
  }, [onschedState])
  
  input.name = formInputKey;
  input.autoFocus = Object.keys(form).indexOf(formInputKey) === 0;
  input.className = `onsched-border-border-color 
                     onsched-dark-color 
                     onsched-primary-border-color-hover 
                     onsched-primary-border-color-active 
                     onsched-primary-border-color-focus 
                     ${input.addClassName ? input.addClassName : ''}
                     ${input.halfcolumn ? 'halfcolumn' : ''}
                    `;

  if (onChange) {
    input.onChange = onChange;
  }
  if (onBlur) {
    input.onBlur = onBlur;
  }
  
  if (input.type === 'checkbox') {
    component = 'div';
    
    input.className += ' FormCheckbox';
  }
  else if (input.type === 'select') {
    input.className += ' FormInput FormDropdown onsched-primary-border-color-focus onsched-primary-border-color-active';
    component = () => FormDropdown({ input, children })
  }
  else {
    input.className += ' FormInput';
  }

  if (input.display === "false") {
    input.className = 'hide';
  }

  if (document.getElementsByName(input.name)[0]) {
    if (Array.from(document.getElementsByName(input.name)[0].parentElement.children).indexOf(document.getElementsByName(input.name)[0]) === 0) {
      if (!input.className.includes('hide')) {
        if (Array.from(document.getElementsByName(input.name)[0].parentElement.children)[1]?.classList.contains('hide')) {
          input.className += ' stretch';
        }
      }
    }
    else if (Array.from(document.getElementsByName(input.name)[0].parentElement.children).indexOf(document.getElementsByName(input.name)[0]) === 1) {
      if (!input.className.includes('hide')) {
        if (Array.from(document.getElementsByName(input.name)[0].parentElement.children)[0]?.classList.contains('hide')) {
          input.className += ' stretch';
        }
      }
    }
  }

  return React.createElement(
    component,
    input,
    children
  );
}

export default FormElement;
